import type { NewsShape } from '$lib/sanity/schemas/entities';

import Circle from './circle.svelte';
import Clover from './clover.svelte';
import HalfPill from './halfPill.svelte';
import Hexagon from './hexagon.svelte';
import Oval from './oval.svelte';
import Triangle from './triangle.svelte';

export const getIconByShape = (shape?: NewsShape | null) => {
  switch (shape) {
    case 'circle':
      return Circle;
    case 'clover':
      return Clover;
    case 'halfPill':
      return HalfPill;
    case 'hexagon':
      return Hexagon;
    case 'oval':
      return Oval;
    case 'triangle':
      return Triangle;
    default:
      return Oval;
  }
};
